import React, { useEffect, useState } from "react";

interface ReCaptcha {
  ready: (cb: () => unknown) => void;
  execute: (siteKey: string, options: { action: string }) => Promise<string>;
}

declare global {
  interface Window {
    grecaptcha: ReCaptcha;
  }
}

export function useReCaptcha(action: string) {
  const scriptElId: string = "ReCaptcha-script";
  const siteKey: string = "6LfEYMEUAAAAAFt1jw1PpoP3Ew6QGKNyqSfJ6GkA";

  const [scriptLoaded, setScriptLoaded] = useState<boolean>();

  useEffect(() => {
    if (!document.getElementById(scriptElId)) {
      const script: HTMLScriptElement = document.createElement("script");

      script.id = scriptElId;
      document.head.appendChild(script);

      script.onload = handleScriptLoaded;
      script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;

      return () => {
        document.head.removeChild(script);
      };
    }
  }, [siteKey, action]);

  const handleScriptLoaded = () => {
    setScriptLoaded(true);
  };

  const execute = async () => {
    return new Promise<string>((resolve, reject) => {
      if (scriptLoaded) {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(siteKey, { action }).then(
            (token: string) => {
              resolve(token);
            },
            (err: string) => {
              reject(err);
            }
          );
        });
      } else {
        reject("ReCaptcha script isn't loaded");
      }
    });
  };

  return { execute };
}
